export default function bcyclePopup(model) {
	return `<div class='content-wrapper clearfix'>
	<h3 id='popup-name'>${model.data.name}</h3>
	<div class='bcycle-available' data-bcycle-realtime='${model.data.id}' aria-live='polite'>
		<p class='loading'>
			Loading data \u2026
			<svg class='loading-icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'>
				<path
					opacity='.4'
					d='M41 403.1l67.9-67.9 67.9 67.9L108.9 471 41 403.1zM208 416l96 0 0 96-96 0 0-96zM335.2 108.9L403.1 41 471 108.9l-67.9 67.9-67.9-67.9zm0 294.2l67.9-67.9L471 403.1 403.1 471l-67.9-67.9zM416 208l96 0 0 96-96 0 0-96z'
				/>
				<path
					d='M208 96l96 0 0-96L208 0l0 96zM0 208l0 96 96 0 0-96L0 208zm41-99.1l67.9 67.9 67.9-67.9L108.9 41 41 108.9z'
				/>
			</svg>
		</p>
	</div>
</div>`;
}
